<template>
  <div class="swiper_vr_video_img">
    <div class="photo_swiper" v-if="pageInfo.Extinfo.buildingBanner">
      <swiper class="innner_swiper" ref="innerSwiper" :options="swiperOption">
        <swiperSlide v-for="(item,index) in photoList" :key="index">
          <video-player
            v-if="item.type==1"
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="item.playerOptions"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
          ></video-player>
          <div
            class="video_cover"
            @click="clickPlayInMp"
            v-if="item.type==1&&isInMiniProgram&&isShowVideoCover"
          ></div>
          <img v-if="item.type==2" v-lazy="item.img" @click="clickVr(item)" alt />
          <img v-if="item.type==3" v-lazy="item.img" @click="clickImg(item)" />
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <!-- <div v-if="showDirect" class="direct-area">       -->
      <div v-if="showDirect" class="direct-layer" :class="classObject()">
        <div
          class="tag"
          v-for="(item,idx) in directList"
          :class="{'active': directActIdx == idx}"
        >{{item.name}}</div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import Vue from "vue";
import { videoPlayer } from "vue-video-player";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "video.js/dist/video-js.css";
import "swiper/dist/css/swiper.css";
import wx from "weixin-js-sdk";
let that100 = null;
export default {
  components: {
    swiper,
    swiperSlide,
    videoPlayer
  },
  props: {},
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          slideChange: function() {
            console.log("slideChange===>activeIndex", this.activeIndex);
            that100.changeSwiper(this.activeIndex);
          },
          slideNextTransitionStart() {}
        }
      },
      photoList: [],
      directList: [],
      playerList: [],

      directActIdx: 0,

      hasVideo: false,
      hasVr: false,
      hasImg: false,
      showDirect: true,
      isShowVideoCover: false
    };
  },
  watch: {},
  computed: {
    ...mapState(["isInMiniProgram", "pageInfo"]),
    classObject() {
      return function() {
        switch (this.directList.length) {
          case 1:
            return {
              i1: true
            };
            break;
          case 2:
            return {
              i2: true
            };
            break;
          case 3:
            return {
              i3: true
            };
            break;
        }
      };
    }
  },
  methods: {
    changeSwiper(idx) {
      //滑动后暂停播放
      let that = this;
      that.playerList.forEach(item => {
        if (item) {
          item.pause();
        }
      });

      //切换选项(选中对应的tab)
      that.photoList.forEach((item, index) => {
        if (index == idx) {
          that.directList.forEach((e, i) => {
            if (e.type == item.type) {
              that.directActIdx = i;
            }
          });
        }
      });

      that.showDirect = true;
    },
    clickPlayInMp() {
      if (util.checkIsHuafaTest()) {
        // 小程序内打开新的播放
        wx.miniProgram.navigateTo({
          url: `/pages/txv_video/txv_video?vid=y0939zfi743`
        });
      }
    },
    onPlayerPlay(player) {
      this.showDirect = false;
      this.playerList.push(player);
      console.log("开始播放", player);
      console.log("this.playerList", this.playerList);
      this.playerList.forEach(item => {
        if (item != player) {
          item.pause();
        }
      });
    },
    onPlayerPause(player) {
      this.showDirect = true;
    },
    clickImg(item) {
      // let tmpObj = {
      //   id: this.$route.query.id,
      //   psn: this.$route.query.psn
      // };
      // if (this.$route.query.refereeopenid) {
      //   tmpObj.refereeopenid = this.$route.query.refereeopenid;
      // }
      // if (this.$route.query.rscuid) {
      //   tmpObj.rscuid = this.$route.query.rscuid;
      // }
      // if (this.$route.query.t9id) {
      //   tmpObj.t9id = this.$route.query.t9id;
      // }
      // if (this.$route.query.t9psn) {
      //   tmpObj.t9psn = this.$route.query.t9psn;
      // }
      // tmpObj.type = item.selectedAroundType;
      // this.$router.push({
      //   name: "t7_photo",
      //   params: {},
      //   query: tmpObj
      // });
      util.openYqRsMakeLink(
        `${location.protocol}//${location.host}/h5/t7_photo`
      );
    },
    // lj59
    clickVr(item) {
      util.openUrl(item.videosrc);
    },
    getPhoto() {
      let tmpList = [];
      //视频VR
      // type 1 视频 2 VR 3 图片
      if (
        this.pageInfo.Extinfo &&
        this.pageInfo.Extinfo.video &&
        this.pageInfo.Extinfo.video.length > 0
      ) {
        this.pageInfo.Extinfo.video.forEach(item => {
          if (item.videosrc) {
            if (item.videosrc.indexOf("assets.") > -1) {
              if (util.checkIsHuafaPro() && this.isInMiniProgram) {
                //华发生产环境且小程序中 不添加视频
              } else {
                this.hasVideo = true;
                //视频
                tmpList.push({
                  img: item.main_img,
                  videosrc: item.videosrc,
                  type: 1,
                  playerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: "zh-CN",
                    aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [
                      {
                        src: item.videosrc, // 路径
                        type: "video/mp4" // 类型
                      }
                    ],
                    poster: item.main_img, //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                      timeDivider: true,
                      durationDisplay: true,
                      remainingTimeDisplay: false,
                      fullscreenToggle: true //全屏按钮
                    }
                  }
                });
              }
            } else {
              let isIN = false;
              let url = item.videosrc;
              this.global.MP_DOMAIN.BUSINESS_HUAFA.forEach(item => {
                if (url.indexOf(item) > -1) {
                  isIN = true;
                }
              });
              if (util.checkIsHuafa() && this.isInMiniProgram && !isIN) {
                //华发小程序且不在安全域名内的vr则不展示
              } else {
                this.hasVr = true;
                //VR
                tmpList.push({
                  img: item.main_img,
                  videosrc: url,
                  type: 2
                });
              }
            }
          }
        });
      }
      //图片
      if (
        this.pageInfo.Extinfo &&
        this.pageInfo.Extinfo.samplePlate &&
        this.pageInfo.Extinfo.samplePlate.length > 0
      ) {
        this.hasImg = true;
        //内景
        this.pageInfo.Extinfo.samplePlate.forEach(item => {
          tmpList.push({
            img: item.main_img,
            type: 3,
            selectedAroundType: 1
          });
        });
      }
      if (
        this.pageInfo.Extinfo &&
        this.pageInfo.Extinfo.envImages &&
        this.pageInfo.Extinfo.envImages.length > 0
      ) {
        this.hasImg = true;
        //周边
        this.pageInfo.Extinfo.envImages.forEach(item => {
          tmpList.push({
            img: item.main_img,
            type: 3,
            selectedAroundType: 2
          });
        });
      }
      // if (
      //   this.pageInfo.Extinfo &&
      //   this.pageInfo.Extinfo.floorPlan &&
      //   this.pageInfo.Extinfo.floorPlan.length > 0
      // ) {
      //   this.hasImg = true;
      //   //户型
      //   this.pageInfo.Extinfo.floorPlan.forEach(item => {
      //     tmpList.push({
      //       img: item.main_img,
      //       type: 3,
      //       selectedAroundType: 3
      //     });
      //   });
      // }
      this.photoList = tmpList;

      let tmp = [];
      this.photoList.forEach(e => {
        if (e.type == 1 && !this.checkIsInDirect(1)) {
          this.directList.push({
            name: "视频",
            type: 1
          });
        }
        if (e.type == 2 && !this.checkIsInDirect(2)) {
          this.directList.push({
            name: "VR",
            type: 2
          });
        }
        if (e.type == 3 && !this.checkIsInDirect(3)) {
          this.directList.push({
            name: "图片",
            type: 3
          });
        }
      });
      // if(this.hasVideo) {
      //   this.directList.push({
      //     name: '视频',
      //     type: 1
      //   })
      // }
      // if(this.hasVr) {
      //   this.directList.push({
      //     name: 'VR',
      //     type: 2
      //   })
      // }
      // if(this.hasImg) {
      //   this.directList.push({
      //     name: '图片',
      //     type: 3
      //   })
      // }
    },

    checkIsInDirect(type) {
      let flag = false;
      this.directList.forEach(e => {
        if (e.type == type) {
          flag = true;
        }
      });
      return flag;
    }
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      this.getPhoto();
    });
    if (util.checkIsHuafaTest()) {
      this.isShowVideoCover = true;
    }
  },
  mounted() {
    that100 = this;
  }
};
</script>

<style lang="css" scoped>
.photo_swiper >>> .vjs-big-play-button {
  top: 50% !important;
  left: 50% !important;
  height: 1rem !important;
  width: 1rem !important;
  line-height: 1rem !important;
  margin-top: -0.5rem !important;
  margin-left: -0.5rem !important;
  border-radius: 1rem !important;
  font-size: 3em !important;
}
.photo_swiper {
  width: 100%;
  height: 4.22rem;
  position: relative;
}

.photo_swiper .swiper-slide {
  width: 100% !important;
  height: 4.22rem;
}

.photo_swiper .swiper-slide > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.direct-area {
  position: absolute;
  height: 0.42rem;
  background: rgba(0, 0, 0, 1);
  opacity: 0.76;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.direct-layer {
  position: absolute;
  bottom: 0;
  left: 50%;
  background-color: #000;
  /*background-color: rgba(255, 255, 255, 0.8);*/
  border-radius: 0.42rem;
  height: 0.42rem;
  line-height: 0.42rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.direct-layer.i1 {
  margin-left: -0.7rem;
}
.direct-layer.i2 {
  margin-left: -1.4rem;
}
.direct-layer.i3 {
  margin-left: -2.1rem;
}
.direct-layer .tag {
  text-align: center;
  color: #fff;
  font-size: 0.24rem;
  width: 1.4rem;
  line-height: 0.42rem;
}
.direct-layer .tag.active {
  border-radius: 0.42rem;
  background-color: #d4a683;
  color: #fff;
  height: 0.42rem;
}
.video_cover {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 28px;
}
</style>